const styles = (theme) => ({
  containerStyle: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    padding: "16 26 8 26"
  },
  actionButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  confirmButton: {
    fontSize: theme.textFontSize,
    textTransform: "none",
    borderRadius: "2px",

    margin: "10 0 10 5",
    "&$disabledConfirmButton,&$disabledConfirmButton:hover": {
      color: theme.iconColor,
    },
  },
  disabledConfirmButton: {
    cursor: "not-allowed",
    pointerEvents: "all",
    color: theme.iconColor,
  },
  sectionTitle: {
    fontSize: theme.textFontSize,
    textTransform: "uppercase",
    textAlign: "center",
    color: theme.dispatchPanelHeaderColor,
  },
  selectRoot: {
    marginTop: 8,
    marginBottom: 4,
  },
  sectionDisabled: {
    backgroundColor: theme.loaderBgColorTranslucent,
    pointerEvents: "none",
  },
  flexRow: {
    display: "flex",
    position: "relative",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
});

export default styles;
